const SideMenu = ({ children }) => {
    return (
        <div className="main-content__calendar-side-menu">
            {children}
        </div>
    );
};

export default SideMenu;
